import React from 'react';
import { Helmet } from 'react-helmet';

import { formatPageTitle } from '../../utils/common';
import ReimbursementsDetailsOnPeriodView from '../payments/limit-one-receipt-reimbursements/details';

const ReceiptDetailsWrapper = props => {
  return (
    <>
      <Helmet>
        <title>{formatPageTitle('Receipt Details')}</title>
      </Helmet>
      <ReimbursementsDetailsOnPeriodView {...props} viewType="receipt" />;
    </>
  );
};

export default ReceiptDetailsWrapper;
